import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
export function FooterSection() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="py-8 border-t border-card-border bg-card/30" data-id="element-92">
        <div className="container mx-auto px-4 max-w-4xl flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-93">
          <p className="text-gray-500 text-sm" data-id="element-94">
            © {new Date().getFullYear()} Bases del Entrenamiento de Fuerza.
            Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-95">
            <button onClick={() => setPrivacyOpen(true)} className="text-sm text-gray-500 hover:text-primary transition-colors underline-offset-4 hover:underline" data-id="element-96">
              Política de Privacidad
            </button>
            <button onClick={() => setTermsOpen(true)} className="text-sm text-gray-500 hover:text-primary transition-colors underline-offset-4 hover:underline" data-id="element-97">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-98">
        <p className="text-gray-400 text-sm italic" data-id="element-99">
          Última actualización: Marzo 2026
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-100">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-101">
          Al realizar una compra en nuestro sitio, recopilamos la siguiente
          información personal: nombre completo, dirección de correo electrónico
          y datos de pago necesarios para procesar la transacción. No
          almacenamos datos de tarjetas de crédito ni débito en nuestros
          servidores.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-102">
          2. Uso de la Información
        </h3>
        <p data-id="element-103">
          Utilizamos tu información personal exclusivamente para: procesar tu
          compra y enviarte el enlace de descarga del producto, comunicarnos
          contigo en caso de ser necesario respecto a tu pedido, y enviarte
          actualizaciones del producto si las hubiera.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-104">3. Protección de Datos</h3>
        <p data-id="element-105">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción. Todas las transacciones se
          procesan a través de plataformas de pago seguras con encriptación SSL.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-106">
          4. Compartir Información
        </h3>
        <p data-id="element-107">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. La única excepción son los proveedores de servicios de pago
          que procesan tu transacción de forma segura.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-108">5. Cookies</h3>
        <p data-id="element-109">
          Nuestro sitio puede utilizar cookies para mejorar la experiencia del
          usuario. Podés configurar tu navegador para rechazar cookies, aunque
          esto podría afectar algunas funcionalidades del sitio.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-110">6. Tus Derechos</h3>
        <p data-id="element-111">
          Tenés derecho a acceder, rectificar o eliminar tu información personal
          en cualquier momento. Para ejercer estos derechos, podés contactarnos
          a través de nuestro correo electrónico de soporte.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-112">7. Contacto</h3>
        <p data-id="element-113">
          Si tenés preguntas sobre esta política de privacidad, podés
          contactarnos por correo electrónico. Responderemos tu consulta en un
          plazo máximo de 48 horas hábiles.
        </p>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-114">
        <p className="text-gray-400 text-sm italic" data-id="element-115">
          Última actualización: Marzo 2026
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-116">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-117">
          Al acceder y realizar una compra en este sitio, aceptás estos términos
          y condiciones en su totalidad. Si no estás de acuerdo con alguno de
          estos términos, te pedimos que no realices la compra.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-118">2. Producto Digital</h3>
        <p data-id="element-119">
          El "Pack Bases del Entrenamiento de Fuerza" es un producto 100%
          digital que incluye archivos en formato PDF. Una vez realizada la
          compra, recibirás un enlace de descarga inmediata en tu correo
          electrónico. El acceso al producto es de por vida.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-120">3. Uso del Producto</h3>
        <p data-id="element-121">
          El producto adquirido es para uso personal y profesional del
          comprador. Queda prohibida la reproducción, distribución, reventa o
          compartición del material con terceros sin autorización expresa. El
          uso del material es exclusivamente para fines educativos y de consulta
          profesional.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-122">
          4. Propiedad Intelectual
        </h3>
        <p data-id="element-123">
          Todo el contenido del pack, incluyendo textos, ilustraciones, diseños
          y estructura, está protegido por derechos de autor. La compra del
          producto otorga una licencia de uso personal, no la transferencia de
          derechos de propiedad intelectual.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-124">5. Pago y Precio</h3>
        <p data-id="element-125">
          El precio del producto es el indicado en la página de venta al momento
          de la compra. El pago es único, sin suscripciones ni cargos
          recurrentes. Los precios pueden variar sin previo aviso, pero el
          precio pagado al momento de la compra será respetado.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-126">6. Entrega</h3>
        <p data-id="element-127">
          Al completar la compra, recibirás automáticamente un correo
          electrónico con el enlace de descarga. Si no recibís el correo en un
          plazo de 24 horas, contactanos para resolver la situación.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-128">
          7. Limitación de Responsabilidad
        </h3>
        <p data-id="element-129">
          El material proporcionado tiene fines educativos y de consulta. No nos
          hacemos responsables por el uso inadecuado del contenido ni por
          resultados específicos derivados de su aplicación. El profesional es
          responsable de adaptar el contenido a las necesidades de sus alumnos o
          clientes.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-130">8. Modificaciones</h3>
        <p data-id="element-131">
          Nos reservamos el derecho de modificar estos términos y condiciones en
          cualquier momento. Las modificaciones entrarán en vigor desde su
          publicación en el sitio. Las compras realizadas antes de cualquier
          modificación se regirán por los términos vigentes al momento de la
          compra.
        </p>

        <h3 className="text-lg font-bold text-white" data-id="element-132">9. Contacto</h3>
        <p data-id="element-133">
          Para cualquier consulta sobre estos términos y condiciones, podés
          contactarnos por correo electrónico. Responderemos tu consulta en un
          plazo máximo de 48 horas hábiles.
        </p>
      </Modal>
    </>;
}